import React from 'react';
import styled from 'styled-components';
import IconAdd from 'images/others/button-add.svg';
import IconClear from 'images/others/button-clear.svg';
import IconRemove from 'images/others/button-remove.svg';
import ButtonNew from 'components/ButtonAppNew';

export const StyleFilters = styled.div`
  width: 100%;
  display: flex;
  margin-left: auto;
  padding: 14px 0;

  button:not(:last-child) {
    margin-right: 12px;
  }

  button:last-child {
    margin-left: auto;
  }
`;

const Filters = ({
  handleToggleUserDialog,
  handleClearUsersSelection,
  handleToggleRemoveTag,
  handleRemoveUsersTagsToggle,
}) => {
  return (
    <StyleFilters>
      <ButtonNew
        onClick={handleToggleUserDialog}
      >
        <img src={IconAdd} alt="add" />
        add tag
      </ButtonNew>

      <ButtonNew
        onClick={handleRemoveUsersTagsToggle}
      >
        <img src={IconRemove} alt="remove" />
        Remove tag
      </ButtonNew>

      <ButtonNew
        onClick={handleClearUsersSelection}
        color="primary"
      >
        <img src={IconClear} alt="clear" />
        Clear selection
      </ButtonNew>

      <ButtonNew variant="outlined" color="primary">
        download
      </ButtonNew>
    </StyleFilters>
  );
};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Filters/Filters.jsx